import { FONT_SIZE, EllipsisAccordion } from "@dmm-com/rocket-web-ui-library";
import { useState } from "react";
import * as Styled from "./style";
import { useHandleClickByDevice } from "~/hooks/use-handle-click-by-device";

type ReviewContentProps = {
  /** ネタバレの場合`true`になる */
  hasSpoiler: boolean;
  /** レビューコメント */
  comment: string;
};

/** ネタバレの場合とネタバレでない場合の条件分岐を行うコンポーネント */
export const ReviewContent = ({ hasSpoiler, comment }: ReviewContentProps) => {
  const [isOpenSpoiledText, setIsOpenSpoiledText] = useState(false);

  const { handleClickByDevice } = useHandleClickByDevice();

  if (!hasSpoiler) {
    return (
      <Styled.DivReviewRoot>
        <EllipsisAccordion label="review-comment" fontSize={FONT_SIZE.S} line={3} lineHeight={1.6} text={comment} />
      </Styled.DivReviewRoot>
    );
  }

  return (
    <Styled.DivReviewRoot>
      {!isOpenSpoiledText ? (
        <>
          <Styled.ParSpoilerAlertMessage>
            ※このレビューは作品の内容に関する記述が含まれています。
          </Styled.ParSpoilerAlertMessage>
          <Styled.BtnOpenText type="button" {...handleClickByDevice(() => setIsOpenSpoiledText(true))}>
            レビューを表示する
          </Styled.BtnOpenText>
        </>
      ) : (
        <EllipsisAccordion label="review-comment" fontSize={FONT_SIZE.S} line={3} lineHeight={1.6} text={comment} />
      )}
    </Styled.DivReviewRoot>
  );
};
